import {
  GETISSUERS_SUCCESS,
  GETLOG_SUCCESS,
  GET_ADMIN_LOG,
  GET_ISSUER_ADMIN_LOG
} from '../types';

const initialState = {
  issuersData: [],
  logs: [],
  adminLog: [],
  issuerAdminLog: []
};

export default function LogReducers(state = initialState, action) {
  switch (action.type) {
    case GETISSUERS_SUCCESS:
      return {
        ...state,
        issuersData: action.payload.data
      };
    case GETLOG_SUCCESS:
      return {
        ...state,
        logs: action.payload
      };
    case GET_ADMIN_LOG:
      return {
        ...state,
        adminLog: action.payload
      };
    case GET_ISSUER_ADMIN_LOG:
      return {
        ...state,
        issuerAdminLog: action.payload
      };
    default:
      return state;
  }
}
